import { Injectable } from '@angular/core';
import { NavigationExtras, Params, Router } from '@angular/router';
import { ErrorService } from '@shared/services/error.service';

@Injectable({
  providedIn: 'root',
})
export class PlRouter {
  constructor(
    private errorService: ErrorService,
    private router: Router,
  ) {}

  public get url(): string {
    return this.router.url;
  }

  public navigate(commands: any[], extras?: NavigationExtras, event?: MouseEvent): Promise<boolean> {
    if (this.isCtrlClicked(event) && Array.isArray(commands) && commands.length > 0) {
      window.open(commands[0], '_blank');
      return Promise.resolve(true);
    } else {
      this.errorService.hideError();
      return this.router.navigate(commands, extras);
    }
  }

  public isCtrlClicked(event?: MouseEvent): boolean {
    if (event) {
      return event.ctrlKey || event.metaKey;
    }

    return false;
  }

  public removeQueryParamFromUrl(paramsKey: string | string[]): Promise<boolean> {
    const queryParamsToUpdateInUrl: Params = {};
    if (typeof paramsKey === 'string') {
      queryParamsToUpdateInUrl[paramsKey] = null;
    } else {
      paramsKey.forEach((key: string): void => {
        queryParamsToUpdateInUrl[key] = null;
      });
    }

    return this.navigate([], {
      queryParams: queryParamsToUpdateInUrl,
      queryParamsHandling: 'merge',
    });
  }
}
